import { ComponentProps, ReactNode } from 'react';
import { Box, BoxProps } from 'reflexbox';
import styled from 'styled-components';
import { mix } from 'polished';

const Span = styled.span`
	background: ${(props) => mix(0.8, props.theme.colors.white, props.theme.colors.primary)};
	color: ${(props) => props.theme.colors.primary};
	padding: 2px 1px;
	margin: -2px -1px;
	border-radius: 2px;
`;

export function useHighlighter(props: { query: string }) {
	return {
		score: (candidate: string) => {
			const words = props.query.match(/([a-z]+|[0-9]+)/gi) ?? [];

			if (words.length === 0) {
				return 1;
			}

			const matches = candidate.match(new RegExp(`(${words.join('|')})`, 'ig')) ?? [];

			return (matches.length ?? 0) / words.length;
		},
	};
}

export function Highlight(props: BoxProps & { query?: string; children: string | string[] }) {
	if (!props.query) {
		return <Box {...(props as ComponentProps<typeof Box>)}>{props.children}</Box>;
	}

	const children = Array.isArray(props.children) ? props.children.join('') : props.children;

	const words = props.query.match(/([a-z]+|[0-9]+)/gi) ?? [];

	const result: ReactNode[] = [];

	if (words.length > 0) {
		const regexp = new RegExp(`(${words.join('|')})`, 'ig');

		let match = regexp.exec(children);
		let last = 0;

		while (match) {
			result.push(children.substring(last, match.index));
			result.push(<Span>{match[0]}</Span>);

			last = match.index + match[0].length;
			match = regexp.exec(children);
		}

		result.push(children.substring(last));
	} else {
		result.push(children);
	}

	return <Box {...(props as ComponentProps<typeof Box>)}>{result}</Box>;
}
